import React, { useState } from "react";
import SlateInput from "./components/SlateInput";
import LetterAnimator from "./components/LetterAnimation";
import Pronounce from "./components/Pronounce";
import LanguageSelector from "./components/LanguageSelector";
import LessonTracker from "./components/LessonTracker";
import "./ChalkSlate.css";

function ChalkSlate() {
  const [letter, setLetter] = useState("");
  const [speed, setSpeed] = useState("slow");
  const [language, setLanguage] = useState("en");

  return (
    <div className="chalkboard-app">
      <header className="chalkboard-header">
        <LanguageSelector setLanguage={setLanguage} />
        <h1 className="chalk-title">Learn to Write!</h1>
        <LessonTracker letter={letter} />
      </header>

      <main className="chalkboard-main">
        <SlateInput setLetter={setLetter} setSpeed={setSpeed} />
        <LetterAnimator letter={letter} speed={speed} />
        <Pronounce letter={letter} language={language} />
      </main>

      <footer className="chalkboard-footer">
        <p>Completed Letters: <span className="completed">A B C D E</span></p>
      </footer>
    </div>
  );
}

export default ChalkSlate;
